export default {
 lang_name: '日本語',
 tab_mine: '採掘', tab_upgrade: '強化', tab_prestige: '転生', tab_achievement: '実績', tab_settings: '設定',
 hud_cps: '/秒', hud_tap: '/タップ', hud_combo: 'x',
 action_daily_bonus: 'デイリーボーナス', action_turbo: 'ターボ', action_ad_boost: '広告ブースト',
 gen_gen1: 'スマホ採掘', gen_gen2: 'ノートPC採掘', gen_gen3: 'デスクトップ採掘', gen_gen4: 'GPUリグ', gen_gen5: 'ASICマイナー', gen_gen6: '採掘ファーム', gen_gen7: 'データセンター', gen_gen8: '量子コンピュータ', gen_gen9: 'AIマイニングボット', gen_gen10: '衛星マイナー', gen_gen11: '月面採掘基地', gen_gen12: '銀河採掘ネットワーク',
 gen_gen1_theme: 'ポケット副業', gen_gen2_theme: 'カフェコイン農家', gen_gen3_theme: 'ネカフェバイト', gen_gen4_theme: 'グラボ争奪戦', gen_gen5_theme: 'プロ機材', gen_gen6_theme: 'コンテナファーム', gen_gen7_theme: '企業インフラ', gen_gen8_theme: '未来技術', gen_gen9_theme: '自律採掘', gen_gen10_theme: '宇宙拡張', gen_gen11_theme: '月面征服', gen_gen12_theme: '宇宙支配',
 locked: 'ロック中',
 upg_cat_generator: '生産機アップグレード', upg_cat_global: 'グローバルアップグレード', upg_cat_research: '研究', upg_cat_darkpool: 'ダークプール',
 upg_empty: 'アップグレード未解放', upg_empty_hint: '生産機を購入してアンロック',
 upg_up_gen1_t1: 'スマホ効率化', upg_up_gen1_t1_desc: 'スマホ採掘x2', upg_up_gen1_t2: 'スマホ特化', upg_up_gen1_t2_desc: 'スマホ採掘x2', upg_up_gen1_t3: 'スマホマスター', upg_up_gen1_t3_desc: 'スマホ採掘x2',
 upg_up_gen2_t1: 'ノートPC効率化', upg_up_gen2_t1_desc: 'ノートPC採掘x2', upg_up_gen2_t2: 'ノートPC特化', upg_up_gen2_t2_desc: 'ノートPC採掘x2', upg_up_gen2_t3: 'ノートPCマスター', upg_up_gen2_t3_desc: 'ノートPC採掘x2',
 upg_up_gen3_t1: 'デスクトップ効率化', upg_up_gen3_t1_desc: 'デスクトップ採掘x2', upg_up_gen3_t2: 'デスクトップ特化', upg_up_gen3_t2_desc: 'デスクトップ採掘x2', upg_up_gen3_t3: 'デスクトップマスター', upg_up_gen3_t3_desc: 'デスクトップ採掘x2',
 upg_up_gen4_t1: 'GPU効率化', upg_up_gen4_t1_desc: 'GPU採掘x2', upg_up_gen4_t2: 'GPU特化', upg_up_gen4_t2_desc: 'GPU採掘x2', upg_up_gen4_t3: 'GPUマスター', upg_up_gen4_t3_desc: 'GPU採掘x2',
 upg_up_gen5_t1: 'ASIC効率化', upg_up_gen5_t1_desc: 'ASIC採掘x2', upg_up_gen5_t2: 'ASIC特化', upg_up_gen5_t2_desc: 'ASIC採掘x2', upg_up_gen5_t3: 'ASICマスター', upg_up_gen5_t3_desc: 'ASIC採掘x2',
 upg_up_gen6_t1: 'ファーム効率化', upg_up_gen6_t1_desc: 'ファーム採掘x2', upg_up_gen6_t2: 'ファーム特化', upg_up_gen6_t2_desc: 'ファーム採掘x2', upg_up_gen6_t3: 'ファームマスター', upg_up_gen6_t3_desc: 'ファーム採掘x2',
 upg_up_gen7_t1: 'DC効率化', upg_up_gen7_t1_desc: 'DC採掘x2', upg_up_gen7_t2: 'DC特化', upg_up_gen7_t2_desc: 'DC採掘x2', upg_up_gen7_t3: 'DCマスター', upg_up_gen7_t3_desc: 'DC採掘x2',
 upg_up_gen8_t1: '量子効率化', upg_up_gen8_t1_desc: '量子採掘x2', upg_up_gen8_t2: '量子特化', upg_up_gen8_t2_desc: '量子採掘x2', upg_up_gen8_t3: '量子マスター', upg_up_gen8_t3_desc: '量子採掘x2',
 upg_up_gen9_t1: 'AIボット効率化', upg_up_gen9_t1_desc: 'AIボット採掘x2', upg_up_gen9_t2: 'AIボット特化', upg_up_gen9_t2_desc: 'AIボット採掘x2', upg_up_gen9_t3: 'AIボットマスター', upg_up_gen9_t3_desc: 'AIボット採掘x2',
 upg_up_gen10_t1: '衛星効率化', upg_up_gen10_t1_desc: '衛星採掘x2', upg_up_gen10_t2: '衛星特化', upg_up_gen10_t2_desc: '衛星採掘x2', upg_up_gen10_t3: '衛星マスター', upg_up_gen10_t3_desc: '衛星採掘x2',
 upg_up_gen11_t1: '月面効率化', upg_up_gen11_t1_desc: '月面採掘x2', upg_up_gen11_t2: '月面特化', upg_up_gen11_t2_desc: '月面採掘x2', upg_up_gen11_t3: '月面マスター', upg_up_gen11_t3_desc: '月面採掘x2',
 upg_up_gen12_t1: '銀河効率化', upg_up_gen12_t1_desc: '銀河採掘x2', upg_up_gen12_t2: '銀河特化', upg_up_gen12_t2_desc: '銀河採掘x2', upg_up_gen12_t3: '銀河マスター', upg_up_gen12_t3_desc: '銀河採掘x2',
 upg_up_global_click1: '強化フィンガー', upg_up_global_click1_desc: 'タップパワーx2', upg_up_global_click2: 'サイボーグフィンガー', upg_up_global_click2_desc: 'タップパワーx3',
 upg_up_global_cps1: 'オーバークロック', upg_up_global_cps1_desc: '全体自動収入 +50%', upg_up_global_cps2: '極限オーバークロック', upg_up_global_cps2_desc: '全体自動収入 x2',
 upg_up_global_golden1: 'ラッキーアンテナ', upg_up_global_golden1_desc: 'ゴールデン持続+50%', upg_up_global_golden2: 'ゴールデンマグネット', upg_up_global_golden2_desc: 'ゴールデン頻度x2',
 upg_up_global_offline: '自動採掘最適化', upg_up_global_offline_desc: 'オフライン率50%→75%', upg_up_global_combo: 'コンボ延長', upg_up_global_combo_desc: 'コンボ持続3秒→5秒',
 upg_up_res_synergy: 'シナジーアルゴリズム', upg_up_res_synergy_desc: '生産機種類ごと自動収入+10%', upg_up_res_quantum: '量子加速', upg_up_res_quantum_desc: '全体自動収入 x3', upg_up_res_ai_click: 'AIクリック補助', upg_up_res_ai_click_desc: 'タップパワーx5', upg_up_res_golden_master: 'ゴールデンマスター', upg_up_res_golden_master_desc: 'ゴールデン効果x2+持続x2', upg_up_res_prestige_boost: '転生触媒', upg_up_res_prestige_boost_desc: '転生ブロックチェーン+50%', upg_up_res_combo_max: 'コンボブレイカー', upg_up_res_combo_max_desc: '最大コンボ倍率2x→3x',
 upg_up_dp_scam_promo: '詐欺コイン宣伝', upg_up_dp_scam_promo_desc: 'ダークプール報酬x2',
 upg_up_dp_insider_net: 'インサイダーネットワーク', upg_up_dp_insider_net_desc: 'インサイダー精度80%→95%',
 upg_up_dp_chip_laundry: 'ハイローラー', upg_up_dp_chip_laundry_desc: '最大ベット比率25%→50%',
 upg_up_dp_whale_ctrl: 'クジラ操縦', upg_up_dp_whale_ctrl_desc: '8x,12x倍率確率大幅増加',
 prestige_blockchain_title: 'ブロックチェーン転生', prestige_blockchain_held: '保有', prestige_blockchain_bonus: 'ボーナス', prestige_count: '転生回数', prestige_count_unit: '回', prestige_gain: '転生時', prestige_blockchain: 'ブロックチェーン', prestige_execute: '転生する', prestige_need: '総生産量1M以上必要', prestige_current: '現在',
 prestige_buff_title: 'ブロックチェーンバフ', prestige_buff_level: 'Lv.',
 buff_click: 'クリックパワー増幅', buff_click_desc: 'レベルごとタップ+5%', buff_cps: '自動収入増幅', buff_cps_desc: 'レベルごと自動収入+5%', buff_golden: 'ゴールデン確率', buff_golden_desc: 'レベルごとゴールデン+2%', buff_offline: 'オフライン効率', buff_offline_desc: 'レベルごとオフライン+5%',
 buff_ex_seed: 'シードマネー支援', buff_ex_seed_desc: '転生時に開始シードを少し支給', buff_ex_rescue_cd: 'ナンピン回線', buff_ex_rescue_cd_desc: 'ナンピン緊急資金のクールダウンを少し短縮', buff_ex_leak: '内部情報筋', buff_ex_leak_desc: 'リーク情報を少し早く受信',
 prestige2_title: 'メタバース転生', prestige2_coins: 'メタバースコイン', prestige2_count: '2次転生', prestige2_gain: '2次転生時', prestige2_execute: '2次転生', prestige2_need: 'ブロックチェーン100以上必要', prestige2_locked_title: 'メタバース転生', prestige2_locked_desc: '転生5回+ブロックチェーン50必要', prestige2_locked_current: '現在',
 prestige2_meta_title: 'メタバースアップグレード',
 meta_auto_tap: '自動タップボット', meta_auto_tap_desc: '1秒ごと自動タップ', meta_golden_boost: 'ゴールデンブースト', meta_golden_boost_desc: 'ゴールデン頻度x2', meta_offline_time: 'オフライン延長', meta_offline_time_desc: 'オフライン8h→16h', meta_milestone_boost: 'マイルストーンブースト', meta_milestone_boost_desc: 'マイルストーンx2→x3', meta_prestige_amplify: '転生増幅', meta_prestige_amplify_desc: 'ブロックチェーン効果1%→2%',
 prestige_confirm_title: '転生確認', prestige_confirm_gain: '獲得', prestige_confirm_after: '転生後', prestige_confirm_warn_1: 'コイン・生産機リセット', prestige_confirm_keep_1: 'ブロックチェーン・実績維持',
 prestige2_confirm_title: '2次転生', prestige2_confirm_warn: 'コイン・生産機・ブロックチェーン全リセット', prestige2_confirm_keep: 'メタバースコイン・実績維持',
 ach_title: '実績', ach_cat_production: '生産', ach_cat_generator: '生産機', ach_cat_prestige: '転生', ach_cat_click: 'クリック', ach_cat_golden: 'ゴールデン', ach_cat_special: '特殊',
 ach_ach_prod_1: '初コイン', ach_ach_prod_1_desc: 'コイン1生産', ach_ach_prod_2: '百万長者', ach_ach_prod_2_desc: 'コイン1M生産', ach_ach_prod_3: '億万長者', ach_ach_prod_3_desc: 'コイン1B生産', ach_ach_prod_4: '兆長者', ach_ach_prod_4_desc: 'コイン1T生産', ach_ach_prod_5: '京長者', ach_ach_prod_5_desc: 'コイン1Qa生産', ach_ach_prod_6: '垓長者', ach_ach_prod_6_desc: 'コイン1Qi生産', ach_ach_prod_7: '秭長者', ach_ach_prod_7_desc: 'コイン1Sx生産', ach_ach_prod_8: '穣長者', ach_ach_prod_8_desc: 'コイン1Sp生産', ach_ach_prod_9: '溝長者', ach_ach_prod_9_desc: 'コイン1Oc生産', ach_ach_prod_10: '澗長者', ach_ach_prod_10_desc: 'コイン1No生産', ach_ach_prod_11: '正長者', ach_ach_prod_11_desc: 'コイン1Dc生産', ach_ach_prod_12: '載長者', ach_ach_prod_12_desc: 'コイン1UDc生産',
 ach_ach_gen_1: 'スマホマスター', ach_ach_gen_1_desc: 'スマホ100台', ach_ach_gen_2: 'ノートPCマスター', ach_ach_gen_2_desc: 'ノートPC100台', ach_ach_gen_3: 'デスクトップマスター', ach_ach_gen_3_desc: 'デスクトップ100台', ach_ach_gen_4: 'GPUマスター', ach_ach_gen_4_desc: 'GPUリグ100台', ach_ach_gen_5: 'ASICマスター', ach_ach_gen_5_desc: 'ASIC100台', ach_ach_gen_6: 'ファームマスター', ach_ach_gen_6_desc: 'ファーム100台', ach_ach_gen_7: 'DCマスター', ach_ach_gen_7_desc: 'DC100台', ach_ach_gen_8: '量子マスター', ach_ach_gen_8_desc: '量子コンピュータ100台', ach_ach_gen_9: 'AIマスター', ach_ach_gen_9_desc: 'AIボット100台', ach_ach_gen_10: '衛星マスター', ach_ach_gen_10_desc: '衛星100台', ach_ach_gen_11: '月面マスター', ach_ach_gen_11_desc: '月面基地100台', ach_ach_gen_12: '銀河マスター', ach_ach_gen_12_desc: '銀河ネットワーク100台',
 ach_ach_pres_1: '初転生', ach_ach_pres_1_desc: '転生1回', ach_ach_pres_2: '転生マスター', ach_ach_pres_2_desc: '転生10回', ach_ach_pres_3: '転生レジェンド', ach_ach_pres_3_desc: '転生50回', ach_ach_pres_4: 'ブロックチェーン収集家', ach_ach_pres_4_desc: 'ブロックチェーン100個', ach_ach_pres_5: 'メタバース入場', ach_ach_pres_5_desc: '2次転生1回', ach_ach_pres_6: 'メタバース大物', ach_ach_pres_6_desc: '2次転生5回', ach_ach_pres_7: 'ブロックチェーン王', ach_ach_pres_7_desc: 'ブロックチェーン500個', ach_ach_pres_8: '転生神', ach_ach_pres_8_desc: '転生100回',
 ach_ach_click_1: 'クリック初心者', ach_ach_click_1_desc: 'タップ100回', ach_ach_click_2: 'クリックマニア', ach_ach_click_2_desc: 'タップ1,000回', ach_ach_click_3: 'クリック中毒', ach_ach_click_3_desc: 'タップ10,000回', ach_ach_click_4: 'クリック神', ach_ach_click_4_desc: 'タップ100,000回', ach_ach_click_5: '手首破壊者', ach_ach_click_5_desc: 'コンボ50達成', ach_ach_click_6: '10TPSプロ', ach_ach_click_6_desc: 'コンボ100達成',
 ach_ach_golden_1: 'ゴールデンハンター', ach_ach_golden_1_desc: 'ゴールデン10回', ach_ach_golden_2: 'ゴールデンマスター', ach_ach_golden_2_desc: 'ゴールデン50回', ach_ach_golden_3: 'ゴールデンレジェンド', ach_ach_golden_3_desc: 'ゴールデン200回', ach_ach_golden_4: '幸運の手', ach_ach_golden_4_desc: 'ラッキーゴールデン5回',
 ach_ach_spec_1: '広告サポーター', ach_ach_spec_1_desc: '広告10回視聴', ach_ach_spec_2: '広告VIP', ach_ach_spec_2_desc: '広告100回視聴', ach_ach_spec_3: 'オフライン長者', ach_ach_spec_3_desc: 'オフライン10回受取', ach_ach_spec_4: '皆勤王', ach_ach_spec_4_desc: '7日連続出席', ach_ach_spec_5: '完璧主義者', ach_ach_spec_5_desc: '全生産機100台ずつ', ach_ach_spec_6: 'クリックマスター', ach_ach_spec_6_desc: 'コインクリック1,000回', ach_ach_spec_7: 'スピード狂', ach_ach_spec_7_desc: '転生なし1時間で1B', ach_ach_spec_8: '完走者', ach_ach_spec_8_desc: '全実績達成',
 ach_reward_cps: '+{v}% 自動収入', ach_reward_click: '+{v}% タップ', ach_reward_prestige: '転生',
 golden_golden_coin: 'ゴールデンコイン', golden_golden_coin_desc: '自動収入 x777即獲得', golden_lucky_golden: 'ラッキーゴールデン', golden_lucky_golden_desc: '15秒自動収入 x7', golden_click_frenzy: 'クリックフィーバー', golden_click_frenzy_desc: '30秒タップx10', golden_production_boost: '生産ブースト', golden_production_boost_desc: '30秒全生産x5', golden_mega_jackpot: 'メガジャックポット', golden_mega_jackpot_desc: '現在コインx10',
 settings_title: '設定', settings_sound: 'サウンド', settings_bgm: 'BGM', settings_sfx: 'SFX', settings_language: '言語', settings_stats_title: '統計', settings_total_earned: '総生産量', settings_total_taps: '総タップ', settings_max_combo: '最大コンボ', settings_golden_clicks: 'ゴールデンクリック', settings_prestige_count: '転生', settings_prestige2_count: '2次転生', settings_play_time: 'プレイ時間', settings_data_title: 'データ', settings_save: '手動保存', settings_saved: '保存完了!', settings_reset: 'データリセット', settings_reset_confirm: '本当にリセットしますか?',
 offline_title: 'オフラインボーナス', offline_duration: '採掘した', offline_capped: '(最大)', offline_claim: '受け取る', offline_ad_double: '広告x2',
 confirm: '確認', cancel: 'キャンセル',
 ad_cps_boost: '自動収入ブースト30秒', ad_offline_double: 'オフラインx2', ad_prestige_bonus: '転生+50%', ad_timeskip: '2hスキップ', ad_free_docs: '無料ドキュメント', ad_golden_double: 'ゴールデンx2', ad_start_boost: 'スタートブースト', ad_income_x5: '収入x10', ad_tap_x10: 'タップx10',
 ad_income_x5_desc: '15秒間収入10倍',
 ad_timeskip_desc: '2時間即時生産',
 ad_tap_x10_desc: '15秒間タップ10倍',
 ad_popup_income_title: '収入x10ブースト',
 ad_popup_income_desc: '広告を見ると15秒間すべての収入が10倍に！',
 ad_popup_timeskip_title: '2時間タイムスキップ',
 ad_popup_timeskip_desc: '広告を見ると2時間分のコインを即時獲得！',
 ad_popup_tap_title: 'タップパワーx10',
 ad_popup_tap_desc: '広告を見ると15秒間タップパワーが10倍に！',
 ad_popup_watch: '視聴する',
 ad_popup_cancel: '閉じる',
 ach_toast: '達成!',
 action_daily: 'デイリーボーナス',
 gen_locked: 'ロック中',
 prestige_blockchain_owned: '保有ブロックチェーン',
 prestige_reward_prefix: '転生時 ',
 prestige_blockchain_unit: 'ブロックチェーン',
 prestige_btn: '転生する',
 prestige_need_1m: '総生産量4M以上必要',
 prestige_confirm_warn: 'コイン、生産機リセット',
 prestige_confirm_keep: 'ブロックチェーン、実績維持',
 btn_cancel: 'キャンセル',
 prestige2_meta_coins: 'メタバースコイン',
 prestige2_reward_prefix: '2次転生時 ',
 prestige2_meta_unit: 'メタバースコイン',
 prestige2_btn: '2次転生',
 prestige2_need_100: 'ブロックチェーン100個以上必要',
 prestige2_confirm_gain: '獲得',
 prestige2_upgrades_title: 'メタバースアップグレード',
 ach_reward_tap: 'タップ',
 ach_reward_golden: 'ゴールデン',
 ach_unlocked: '達成!',
 settings_stats: '統計',
 stats_total_earned: '総生産量',
 stats_total_clicks: '総タップ',
 stats_max_combo: '最大コンボ',
 stats_golden_clicks: 'ゴールデンクリック',
 stats_prestige_count: '転生',
 stats_prestige2_count: '2次転生',
 stats_play_time: 'プレイ時間',
 settings_data: 'データ',
 toast_saved: '保存完了!',
 settings_reset_title: 'データリセット',
 // Market sentiment
 market_price: '相場',
 manip_sns_hype: 'SNS扇動',
 manip_sns_hype_desc: '相場上昇誘導(30%逆効果)',
 manip_influencer: 'インフルエンサー',
 manip_influencer_desc: '安定的な相場上昇',
 manip_pump_dump: 'ポンプ&ダンプ',
 manip_pump_dump_desc: '急騰後暴落',

 // Dark Pool
 tab_darkpool: 'ダークプール',
 dp_title: 'Dark Pool',
 dp_total_bets: '総ベット',
 dp_banner_soon: 'ダークプール開始',
 dp_banner_live: 'ダークプール開催中！',
 dp_skip_cooldown: '広告を見てすぐ開始',
 dp_wins: '勝利',
 dp_profit: '純利益',
 dp_next_round: '次のラウンドまで',
 dp_bet_hint: '保有コインの一部を賭けよう',
 dp_bet_coins: 'コインベット',
 dp_available: '所持',
 dp_win_preview: '予想報酬',
 dp_real_coins: 'コイン',
 dp_tutorial_title: 'Dark Pool ガイド',
 dp_tutorial_1: 'Dark Poolは仮想チップでコインオークションに参加するミニゲームです。',
 dp_tutorial_2: '毎ラウンド100チップが無料で支給されます。実際のコインは使いません！',
 dp_tutorial_3: '当選時、チップが実際のコインに変換されます。（自動収入基準）',
 dp_tutorial_4: '広告を見るとインサイダー情報を取得できます。（80%の精度）',
 dp_betting: 'ベット中',
 dp_your_bet: '自分のベット',
 dp_get_insider: 'インサイダー情報',
 dp_place_bet: 'ベットする',
 dp_bet_placed: 'ベット完了',
 dp_waiting_result: '結果待ち...',
 dp_revealing: '結果発表中',
 dp_result: '結果',
 dp_you_won: '当選!',
 dp_you_lost: 'ハズレ...',
 dp_claim: '受け取る',
 dp_no_bet: '今回はパス',
 dp_was_winner: '当選!',
 dp_insider_title: 'インサイダー情報',
 dp_insider_hint: 'が上がる確率80%! 予想',
 dp_insider_warn: '* 情報が100%正確とは限りません',
 dp_insider_received: 'インサイダー情報を入手しました!',

 // Golden event modal
 golden_event: 'ゴールデンイベント',
 golden_claim_normal: '受け取る',
 golden_claim_ad: '広告x2',

 // Prestige ad
 prestige_ad_bonus: '広告+100%',

 // Ad boost
 golden_ad_income_x5: 'x10 ブースト',

 // Exchange
 exchange_title: 'Coin Exchange', exchange_buy: 'Buy', exchange_sell: 'Sell', exchange_holdings: 'Holdings', exchange_avg_price: 'Avg', exchange_profit: 'P&L', exchange_unlock: 'Unlock', exchange_locked: 'Locked', exchange_news: 'News', exchange_24h: 'Change',
 news_celeb_tweet: 'Famous influencer mentions PIKA!', news_hack: 'Major exchange hacked!', news_nova_update: 'NOVA network major update!', news_whale_buy: 'Whale buys in bulk!', news_regulation: '️ Regulatory crackdown!', news_frog_burn: 'Massive FROG burn event!', news_bolt_partner: 'BOLT signs major partnership!', news_star_listing: 'STAR listed on major exchange!', news_bull_market: 'Bull market signal!', news_bear_market: 'Bear market warning!',

 // Onboarding
 onboarding_tap: 'タップしてコインを採掘しよう！',
 onboarding_buy: 'コインでジェネレーターを購入！',
 ob_step0: 'コインをタップして採掘！',
 ob_step1: '稼いだコインで取引所に投資してみよう',
 ob_step2: 'このコインを買ってみよう',
 ob_step3: '上がってる！今売れば大儲け！',
 ob_step4: '採掘したコインを取引所で何倍にも！これがこのゲームの核心だ',
 ob_skip: 'スキップ',

 // === 取引所 (v2.0) ===
 tab_exchange: '取引所',
 coin_stonecoin: 'ストーンコイン',
 ex_my_holdings: '保有資産',
 ex_invested: '投資元本',
 ex_valuation: '評価額',
 ex_eval_pnl: '評価損益',
 ex_all_coins: '全コイン',
 coin_nebula: 'ネビュラ',
 coin_chickencoin: 'チキンコイン',
 coin_moonfrog: 'ムーンフロッグ',
 coin_pumpking: 'パンプキング',
 coin_lattice: 'ラティス',
 coin_moonshot: 'ムーンショット',
 coin_pizzaswap: 'ピザスワップ',
 coin_catchain: 'キャットチェーン',
 coin_rocksolid: 'ロックソリッド',
 coin_yolocoin: 'ヨロコイン',
 coin_ramenfi: 'ラーメンファイ',
 coin_ghostnet: 'ゴーストネット',
 coin_crabdao: 'クラブDAO',
 coin_tacotoken: 'タコトークン',
 coin_sockswap: 'ソックスワップ',
 coin_ufomoney: 'UFOマネー',
 coin_doomfloor: 'ドゥームフロア',
 coin_lambodream: 'ランボドリーム',
 coin_diamondpaw: 'ダイヤの手',
 coin_rugbeater: 'ラグビーター',
 coin_sushirocket: 'スシロケット',
 coin_nyanfi: 'ニャンファイ',
 coin_gigachad: 'ギガチャド',
 coin_kimchibase: 'キムチベース',
 coin_popcat: 'ポップキャット',
 coin_baguettefi: 'バゲットファイ',
 coin_vaporwave: 'ベイパーウェイブ',
 coin_brrrcoin: 'ブルルコイン',
 coin_panicsell: 'パニックセル',
 coin_wenmoon: 'ウェンムーン',
 ex_delisted_badge: '上場廃止',
 ex_revived_badge: '復活',
 cnews_list_new: '{coin} が取引所に新規上場 - 初動の熱狂',
 cnews_list_delist: '{coin} 出来高不足で上場廃止 - 保有分は自動清算',
 cnews_list_revive: '{coin} が復活 - リブランドして再上場',
 ex_title: '取引所',
 ex_total_assets: '総資産',
 ex_cash: '保有コイン',
 ex_total_pnl: '総損益率',
 ex_holding_badge: '保有',
 ex_back: '戻る',
 ex_no_holding: 'まだ保有していないコインです',
 ex_amount: '数量',
 ex_avg_price: '平均取得価格',
 ex_value: '評価額',
 ex_pnl: '損益率',
 ex_buy: '買う',
 ex_sell: '売る',
 ex_max: '最大',
 ex_spend: '購入金額',
 ex_sell_amount: '売却数量',
 ex_buy_success: '買い注文約定！',
 ex_sell_success: '売り注文約定！',
 ex_insufficient_funds: 'コインが足りません',
 ex_insufficient_holding: '保有数量が足りません',

 // === Info economy (Sprint 2a) ===
 news_feed_title: '速報',
 news_section_title: '市場ニュース',
 news_ticker_empty: 'まだニュースはありません',
 news_now: 'たった今',
 news_leak_tag: 'リーク',
 leak_verdict_true: '的中',
 leak_verdict_fake: 'ハズレ',
 factcheck_btn: 'ファクトチェック',
 factcheck_sub: '広告を見て真偽を確認',
 factcheck_true: '本物の情報',
 factcheck_fake: '偽リーク',
 leak_confirmed_target: '確認済みターゲット',
 leak_up_1: '{coin}に大口の動きをキャッチ？',
 leak_up_2: '{coin}に近々大型好材料が出るとの噂',
 leak_up_3: '{coin}をインサイダーが静かに買い集め中とか',
 leak_down_1: '{coin}の大量売り準備中？',
 leak_down_2: '{coin}に悪材料が出るという話が...',
 leak_down_3: '{coin}から大口が抜けている兆候',
 cnews_listing: '{coin}、海外大手取引所への上場確定',
 cnews_celebrity: '有名セレブ「{coin}保有中」と発言',
 cnews_partnership: '{coin}財団、大手企業と提携締結',
 cnews_burn: '{coin}大規模バーンイベント発表',
 cnews_upgrade: '{coin}ネットワークアップグレード成功',
 cnews_etf: '{coin} ETF承認間近と報道',
 cnews_payment: '大手通販モール、{coin}決済導入',
 cnews_viral: '{coin}ミームがSNSで爆発的拡散',
 cnews_airdrop: '{coin}保有者向けエアドロップ発表',
 cnews_buyback: '{coin}財団、買い戻しプログラム開始',
 cnews_influencer_news: '登録100万人YouTuberが{coin}を徹底分析',
 cnews_patent: '{coin}開発社、核心技術の特許出願',
 cnews_devs_missing: '{coin}開発チーム音信不通説が拡散',
 cnews_hack: '{coin}ウォレットハッキングの疑い',
 cnews_regulation: '金融当局、{coin}の規制検討開始',
 cnews_delisting: '一部取引所が{coin}上場廃止を検討か',
 cnews_whale_sell: '{coin}大口ウォレットから大量売却検知',
 cnews_lawsuit: '{coin}財団に集団訴訟提起',
 cnews_bug: '{coin}スマートコントラクトにバグ発見',
 cnews_founder_sell: '{coin}創業者が保有分を売却の兆候',
 cnews_fud: '有名アナリスト「{coin}は終わった」と酷評',
 cnews_outage: '{coin}ネットワーク一時停止発生',
 cnews_stone_difficulty: '{coin}採掘難易度が過去最高、マイナー離脱の兆し',
 cnews_stone_museum: '国立博物館、{coin}ジェネシスブロック展示決定',
 cnews_nebula_launch: '{coin}衛星ノード打ち上げ成功',
 cnews_nebula_debris: '{coin}ノード衛星、宇宙ゴミと衝突危機',
 cnews_chicken_payment: '全国チキンチェーン、{coin}決済導入',
 cnews_chicken_flu: '鳥インフル拡大で{coin}コミュニティがパニック',
 cnews_frog_moon: '{coin}コミュニティ「月まで行く」ミーム爆発',
 cnews_frog_pond: '{coin}クジラ「池に帰る」と全量売却',
 cnews_pump_festival: '{coin}カボチャ祭り開催、新規ウォレット急増',
 cnews_pump_probe: '{coin}相場操縦疑惑で調査開始',
 cd_manip_title: '扇動',
 cd_manip_active: '扇動進行中',
 cd_manip_backfire: '逆効果',
 cd_manip_success: '扇動開始！',
 ex_manip_badge: '扇動',
 whale_phase_label: 'クジラ動向',
 whale_phase_dormant: '静観中',
 whale_phase_accumulating: 'クジラ買い集め中',
 whale_phase_pumping: 'ポンプ間近',
 whale_phase_dumping: 'ダンプ警戒',
 whale_tracker_btn: 'クジラウォレット追跡機',
 whale_tracker_sub: '広告を見て動向を確認',
 rescue_btn: 'ナンピン緊急資金',
 rescue_sub: '広告を見て資金を受け取る',
 rescue_cooldown: 'クールダウン',
 rescue_received: '緊急資金を受け取りました！',
 ad_fact_check: 'ファクトチェック',
 ad_whale_tracker: 'クジラ追跡機',
 ad_rescue_funds: '緊急資金',

 // === Volatility engine + rug pull (Sprint 2b) ===
 ex_rug_badge: 'ラグプル',
 cnews_rug_alert: '緊急: {coin} 開発陣ウォレットから大量流出を検出',

 // Loss-aversion ad hooks (Sprint 2b)
 panic_btn: '緊急脱出',
 panic_sub: '広告を見て暴落直前価格で50%売却',
 panic_success: '緊急脱出約定!',
 insurance_btn: 'ラグプル保険',
 insurance_sub: '広告を見て30分間の補償を有効化',
 insurance_active: '保険適用中',
 insurance_payout: '保険金支払い',
 rewind_btn: 'トレード巻き戻し',
 rewind_sub: '広告を見て直前の取引を取り消し',
 rewind_success: '直前の取引を取り消しました',
 ad_panic_sell: '緊急脱出',
 ad_rug_insurance: 'ラグプル保険',
 ad_trade_rewind: 'トレード巻き戻し',

 // Dark pool x exchange link (Sprint 2b)
 cnews_dp_pump: 'ダークプールで注目の{coin}、取引所でも急騰の兆し',

 // === 仮想企業 (Sprint 3a) ===
 co_voltmotors: 'ボルトモータース', co_moonbase: 'ムーンベース', co_hashworks: 'ハッシュワークス', co_moonlightent: '月光エンタ', co_goldenfry: 'ゴールデンフライ', co_pumpcapital: 'パンプキャピタル',
 cnews_co_volt_payment: '{company}、EVの{coin}決済導入を発表',
 cnews_co_volt_recall: '{company}主力EVを大規模リコール、{coin}心理が冷え込み',
 cnews_co_moonbase_listing: '{company}、{coin}をメインボードに昇格',
 cnews_co_moonbase_outage: '{company}サーバー障害、{coin}取引が一時停止',
 cnews_co_hash_rig: '{company}が新型マイニング機を公開、{coin}ハッシュレート急騰',
 cnews_co_hash_shock: '{company}決算ショック、{coin}採掘縮小の懸念',
 cnews_co_mle_idol: '{company}のアイドルが{coin}ミームチャレンジ開始',
 cnews_co_mle_scandal: '{company}所属スターの不祥事、{coin}ミーム熱が急冷',
 cnews_co_gfry_event: '{company}、{coin}決済でチキン半額イベント',
 cnews_co_gfry_ceo: '{company}CEO逮捕、{coin}コミュニティに衝撃',
 cnews_co_pcap_buy: '{company}CEOが{coin}大量購入をツイート',
 cnews_co_pcap_probe: '{company}に強制捜査、{coin}クジラ資金疑惑',

 // === News comment section (Sprint 3a) ===
 ncm_title: 'コメント', ncm_you: '自分', ncm_your_take: 'どう思う?', ncm_open_hint: 'コメントを見る',
 stance_moon: '爆上げ来い', stance_cut: '損切りだ', stance_watch: '様子見', stance_rekt: '含み損は俺だけか',
 // 好材料コメントプール (cmt_up)
 cmt_up_1: 'ガチホは勝つ', cmt_up_2: '今が底だ買え', cmt_up_3: 'これは爆上げ来る', cmt_up_4: 'フルポジ行きます',
 cmt_up_5: 'やっと含み損脱出だ', cmt_up_6: '大口が来た爆上げ', cmt_up_7: 'チャート右肩上がり', cmt_up_8: '今度こそ本当に行く',
 cmt_up_9: 'ブル相場の始まりだ', cmt_up_10: '今買わないと後悔する', cmt_up_11: '出来高が爆発した', cmt_up_12: '損切り組の涙',
 cmt_up_13: '俺の平均取得価格まで戻れ', cmt_up_14: 'これぞ爆上げだ', cmt_up_15: 'ホルダーは笑う', cmt_up_16: '買い増しの時だ',
 cmt_up_17: 'クジラが仕込み中', cmt_up_18: 'このニュースなら2倍は行く', cmt_up_19: 'ついに反発だ', cmt_up_20: 'ガチホ3年目が笑う',
 cmt_up_21: '今乗らないと稲妻乞食', cmt_up_22: '爆上げ来い行くぞ', cmt_up_23: '俺だけコイン持ってない', cmt_up_24: '利確は芸術だ',
 cmt_up_25: '勢力様ここにいます', cmt_up_26: 'シード全ツッパした兄貴たち', cmt_up_27: '今が底だ三日目だけど', cmt_up_28: 'ジャガイモ畑を耕しに来た',
 cmt_up_29: 'ミームコインは雰囲気で買う', cmt_up_30: 'この部屋また先走りだが俺も乗る', cmt_up_31: 'ゴールデンクロス来た', cmt_up_32: '個人投資家を全員焼け',
 cmt_up_33: '噴くぞ掴め', cmt_up_34: 'これは絶対行くに一票', cmt_up_35: '押し目で仕込んだ', cmt_up_36: '底値買い成功',
 cmt_up_37: '今日はカップ麺じゃなく焼肉', cmt_up_38: 'ついに緑ロウソクだ', cmt_up_39: '俺の予言的中', cmt_up_40: '損切りしなくて正解だった',
 cmt_up_41: '出来高乗ってきた本物だ', cmt_up_42: 'このコインリブランド成功しそう', cmt_up_43: '高値更新行くぞ', cmt_up_44: '分割買い全部埋めた',
 cmt_up_45: '今回は感触が違う', cmt_up_46: 'チャートが綺麗に描けてる', cmt_up_47: '含み損が建値まで戻った', cmt_up_48: '支持線反発確認',
 cmt_up_49: '勢力の仕込み跡が見える', cmt_up_50: '爆上げを叫べ', cmt_up_51: 'これが次のテンバガー', cmt_up_52: '今乗っても最終列車じゃない',
 cmt_up_53: '個人投資家の勝利だ', cmt_up_54: '平均取得価格の下で拾った', cmt_up_55: '明日の朝が楽しみだ', cmt_up_56: 'ホルダー認証します',
 cmt_up_57: 'この部屋信じてフル買い', cmt_up_58: '反発の形が出た', cmt_up_59: 'ガチホの頂点はここにいる', cmt_up_60: '今日も右肩上がり感謝',
 cmt_up_61: 'この部屋の連中なんでこんな強気なんだ', cmt_up_62: 'シード全部ぶち込めばよかった悔しい', cmt_up_63: 'ナンピンが神の一手だった', cmt_up_64: '下がるたびに拾ってたら笑ってる',
 cmt_up_65: 'ガチホは裏切らない', cmt_up_66: 'このコイン見るたび欲しくなる買い増す', cmt_up_67: '赤ロウソク見ると心が落ち着く', cmt_up_68: 'クジラの財布が動いたって本当か',
 cmt_up_69: 'カップ麺の汁に涙入れずに済む', cmt_up_70: 'この上昇には根拠がある', cmt_up_71: '損切りした奴は今頃腹痛だろうな', cmt_up_72: 'チャートがやっと言うことを聞く',
 cmt_up_73: 'コインは結局メンタル勝負だ', cmt_up_74: '利確のタイミングだけ掴めばいい', cmt_up_75: 'この部屋久々に雰囲気が温かい', cmt_up_76: '含み損が建値来たら即抜ける',
 cmt_up_77: '今買わないとまた後悔する', cmt_up_78: '勢力が押し上げてるのが伝わる', cmt_up_79: '今日は口座見るのが楽しい', cmt_up_80: 'ガチホ3年目ついに報われる',
 cmt_up_81: 'これ買わないと稲妻乞食になる', cmt_up_82: 'このチャート心臓が高鳴る', cmt_up_83: '指が先に買いを押した', cmt_up_84: 'チキン代は稼いだ今日は',
 cmt_up_85: 'ジャガイモ農業よりマシだこれは', cmt_up_86: 'コインは右肩上がり今日だけは本物', cmt_up_87: 'リーディング部屋信じたのが神の一手', cmt_up_88: '爆上げ行くぞ心臓が破裂する',
 cmt_up_89: 'ガチホ3年目まだ死んでない', cmt_up_90: '俺だけ含み損じゃなかった今回は', cmt_up_91: '利確は芸術損切りは技術', cmt_up_92: 'ナンピンが溺死じゃなく救助になった',
 cmt_up_93: '勢力の後始末の前に脱出成功', cmt_up_94: 'この部屋久々に笑顔が咲いた', cmt_up_95: '俺の口座だけ右肩下がりかと思ってた', cmt_up_96: 'ついにカップ麺卒業だ',
 cmt_up_97: '反発を掴んだ自分を褒める', cmt_up_98: '高値掴みがついに建値目前', cmt_up_99: 'これはテンバガー予約だ', cmt_up_100: '今日は口座が親孝行だ',
 // 悪材料コメントプール (cmt_down)
 cmt_down_1: 'これは大口の操作だ', cmt_down_2: '損切りサインだ', cmt_down_3: 'また含み損俺だけ', cmt_down_4: '今すぐ逃げろ',
 cmt_down_5: 'だから仮想通貨はダメ', cmt_down_6: 'ラグプルの臭いがする', cmt_down_7: '高値掴みした人挙手', cmt_down_8: 'パニック売り開始',
 cmt_down_9: '俺の元本どこ行った', cmt_down_10: 'チャート崩壊した', cmt_down_11: 'このコイン終わった', cmt_down_12: '大口がダンプ開始',
 cmt_down_13: '今のうちに投げろ', cmt_down_14: '涙の損切り', cmt_down_15: 'これが現実か', cmt_down_16: 'もっと早く売れば',
 cmt_down_17: '反発なし逃げろ', cmt_down_18: 'ホルダーは今日も地獄', cmt_down_19: '個人だけ死ぬ', cmt_down_20: 'このニュースなら半値だ',
 cmt_down_21: 'チャートが心電図かよ', cmt_down_22: 'これ上場廃止コースだろ', cmt_down_23: '損切りしたら上がるお約束', cmt_down_24: 'カップ麺でも作りに行く',
 cmt_down_25: '個人投資家の動き見ろよ', cmt_down_26: '含み損だけどガチホでいいか', cmt_down_27: '勢力がまた振り落とし', cmt_down_28: '逃げるのも頭のうち',
 cmt_down_29: 'この部屋またナンピン誘導', cmt_down_30: '俺のシードが瞬殺された', cmt_down_31: 'デッドキャットに気をつけろ', cmt_down_32: '支持線ぶち抜かれた',
 cmt_down_33: 'メンタル崩壊したマジで', cmt_down_34: '今日も青ロウソクパーティ', cmt_down_35: 'これラグプル準備中', cmt_down_36: '個人投資家の骨まで搾るな',
 cmt_down_37: '半値認証します', cmt_down_38: 'ガチホしてたら瞬殺', cmt_down_39: '移動平均線全部割れた', cmt_down_40: '勢力離脱シグナルだ',
 cmt_down_41: '今投げるのが得策', cmt_down_42: '希望回路を回すな', cmt_down_43: 'このコイン答えがない', cmt_down_44: '高値から-80%',
 cmt_down_45: 'ナンピンして全部溶かした', cmt_down_46: 'チャートが階段状の下落', cmt_down_47: '今日も涙のカップ麺', cmt_down_48: 'だからコインはギャンブル',
 cmt_down_49: '個人投資家地獄オープン', cmt_down_50: '先走りがこうなると思った', cmt_down_51: '損切りが正解だ', cmt_down_52: '勢力だけが笑う',
 cmt_down_53: '俺の口座が溶ける', cmt_down_54: 'これは耐えられない', cmt_down_55: '反発待ってたら老ける', cmt_down_56: '結局個人が弾除け',
 cmt_down_57: 'この部屋のコール逆張りで勝てる', cmt_down_58: '損切りボタンが押せない', cmt_down_59: '希望は贅沢だった', cmt_down_60: '今日も口座が焦土化',
 cmt_down_61: 'この部屋また扇動か気をつけろ', cmt_down_62: '俺のシードが溶けてるマジかよ', cmt_down_63: 'ナンピンが正解と聞いてもっと含んだ', cmt_down_64: '俺だけ高値掴みか本当に',
 cmt_down_65: '希望回路もう回すのやめよう俺たち', cmt_down_66: 'このコイン上場廃止コースじゃないか', cmt_down_67: 'カップ麺の代わりに水でも飲むか', cmt_down_68: '損切りできずガチホしてこの有様',
 cmt_down_69: 'クジラが全部投げて出て行ったって', cmt_down_70: 'この下落は根拠がなくて怖い', cmt_down_71: '利確した奴だけ勝ったいつもそうだ', cmt_down_72: 'チャートが地下室を掘りに行く',
 cmt_down_73: 'コインはメンタル勝負と聞いて崩れ落ちた', cmt_down_74: '損切りのタイミング逃したのがデカい', cmt_down_75: 'この部屋の雰囲気が葬式になった', cmt_down_76: '建値は今生では見れなさそう',
 cmt_down_77: '今からでも投げるのが得策か', cmt_down_78: '勢力が個人を全部振り落として出た', cmt_down_79: '今日も口座見るのが怖い', cmt_down_80: 'ガチホ3年目まだマイナス',
 cmt_down_81: 'チャートが心電図かピー音鳴りそう', cmt_down_82: 'チキン代稼ごうとしてチキン店手放した', cmt_down_83: 'この部屋また後始末の始まりだな', cmt_down_84: 'リーディング部屋信じた俺がバカだ',
 cmt_down_85: '指が勝手に買いを押してしまった', cmt_down_86: 'ナンピンしてただ溺死した', cmt_down_87: '俺だけ含み損だ俺だけ含み損だ', cmt_down_88: 'ジャガイモ農業の方がマシだった',
 cmt_down_89: 'コインは右肩上がり俺の口座だけ右肩下がり', cmt_down_90: '今が底だと三日目叫んでる', cmt_down_91: 'ガチホか損切りか正解はもう手遅れ', cmt_down_92: '勢力の後始末に皿ごと突っ込んだ',
 cmt_down_93: '俺のシードどこ行った本気で', cmt_down_94: '逃げるのは頭のうちと言うが俺は違った', cmt_down_95: '反発待ってて白髪になった', cmt_down_96: 'この部屋のコール逆張りすべきだった',
 cmt_down_97: '損切りボタンが物理的に押せない', cmt_down_98: '今日もカップ麺の汁がしょっぱい', cmt_down_99: '希望回路から煙が出てるもう', cmt_down_100: '稲妻乞食コース順調に進行中',
 // NPC一般返信プール (npc_reply)
 npc_reply_1: '確かにその通り', npc_reply_2: 'それはちょっと違う', npc_reply_3: '俺もそう見てる', npc_reply_4: 'お前だけじゃない',
 npc_reply_5: 'チャート見ろ', npc_reply_6: 'もう遅い', npc_reply_7: '待ってみよう', npc_reply_8: '結局大口が勝つ',
 npc_reply_9: '兄貴の予言が当たるか見届けよう', npc_reply_10: '今回はちょっと違う気もする', npc_reply_11: '俺も半分は同意する', npc_reply_12: '結局勢力の手のひらの上さ',
 npc_reply_13: 'ナンピンは慎重にやれよ', npc_reply_14: 'まずクジラの動きを見ないと', npc_reply_15: '損切りラインを守るのが実力だ', npc_reply_16: '確信するときこそむしろ用心しろ',
 // NPC返信 - 強気スタンスに反応 (bull)
 npc_reply_bull_1: '爆上げ、兄貴だけ信じる', npc_reply_bull_2: '俺もフルポジった', npc_reply_bull_3: '今度こそ本当に行くか', npc_reply_bull_4: '調子乗るのは禁物だぞ',
 npc_reply_bull_5: '兄貴信じてフルポジ行く', npc_reply_bull_6: '今回は根拠がありそうだ', npc_reply_bull_7: '俺も下がったとき拾った', npc_reply_bull_8: '勢力が付いたならゲーム終了だ',
 npc_reply_bull_9: 'ガチホの構え俺も決めた', npc_reply_bull_10: 'ナンピンで平均取得価格下げた', npc_reply_bull_11: '赤ロウソクだから買い増した', npc_reply_bull_12: 'この部屋久々に確信持てる',
 npc_reply_bull_13: '利確のタイミングだけしっかり掴もう', npc_reply_bull_14: 'クジラの仕込みなら本物だ', npc_reply_bull_15: '焼肉食う準備しとこう', npc_reply_bull_16: '爆上げ今回は感触いいな',
 // NPC返信 - 弱気スタンスに反応 (bear)
 npc_reply_bear_1: '損切りが正解だったか', npc_reply_bear_2: '含み損は俺だけじゃなかった', npc_reply_bear_3: '臆病者はまず損切り', npc_reply_bear_4: '俺はまだ耐える',
 npc_reply_bear_5: '損切りが正解だったみたいだ', npc_reply_bear_6: 'ナンピンして俺ももっと含んだ', npc_reply_bear_7: '高値掴みは俺だけじゃなかった', npc_reply_bear_8: 'シードが溶ける音が聞こえる',
 npc_reply_bear_9: '希望回路を回すのもうやめよう', npc_reply_bear_10: '利確した奴だけ勝ったな', npc_reply_bear_11: '建値はもう水の彼方だ', npc_reply_bear_12: 'カップ麺コースだ今日も',
 npc_reply_bear_13: '勢力が全部投げて出て行った', npc_reply_bear_14: '地下室を掘るチャート怖い', npc_reply_bear_15: 'メンタル勝負で負けた認める', npc_reply_bear_16: '損切りボタンが押せない',
 // NPC返信 - 中立スタンスに反応 (neut)
 npc_reply_neut_1: '様子見も実力だ', npc_reply_neut_2: '見てるのが最善策', npc_reply_neut_3: '決められなきゃ負けだ', npc_reply_neut_4: '俺もとりあえず待ち',
 npc_reply_neut_5: '確信持てるまで様子見する', npc_reply_neut_6: '根拠のない確信は危険だ', npc_reply_neut_7: 'ナンピンはトレンド見てからだ', npc_reply_neut_8: 'まずクジラの動きを確認しよう',
 npc_reply_neut_9: '出来高ないなら罠かもしれない', npc_reply_neut_10: '損切りライン決めて様子見しよう', npc_reply_neut_11: '赤ロウソクは分割で入る', npc_reply_neut_12: 'この部屋の確信がむしろ不安',
 npc_reply_neut_13: '利確も計画が必要だぞ', npc_reply_neut_14: '地下室行くなら手を出さない', npc_reply_neut_15: 'まずメンタル管理してからだ', npc_reply_neut_16: 'とりあえず様子見が最善策',
 // === 資産ランキング ===
 lb_title: '資産ランキング',
 lb_entry_title: '資産ランキング',
 lb_entry_sub: '総資産の順位 - クジラと競え',
 lb_your_rank: '{total}人中{rank}位',
 lb_your_assets: '自分の総資産',
 lb_best_rank: '最高{rank}位',
 lb_you: '自分',
 lb_footnote: '総資産 = 現金 + 保有コインの評価額。ランカーたちも資産を増やし続ける — 油断すれば抜かれる。',
 // === Fake Signal Rooms (Sprint 3a) ===
 lr_title: 'シグナル部屋', lr_intro: '部屋主のコールを追って、どこが本物か見極めろ。信頼度は表示されない。',
 lr_entry_title: 'シグナル部屋に入室', lr_entry_sub: '部屋主コール・的中率追跡・情報屋',
 lr_no_call: '待機中のコールなし', lr_no_history: '記録なし', lr_track_record: '的中記録',
 lr_hit: '的中', lr_miss: '失敗',
 lr_vip_tag: 'VIP', lr_vip_enter: 'VIP部屋に入室', lr_vip_sub: '広告を見て高信頼部屋の入場券',
 lr_vip_unlocked: 'VIP部屋 解放完了', lr_locked_hint: '高信頼の精鋭部屋・入場券が必要',
 // 部屋名 + 部屋主紹介
 room_newbie: '初心者脱出部屋', room_newbie_tag: '「問答無用のフルベット！今日も行くぞ！」',
 room_diamond: 'ダイヤホルダー部屋', room_diamond_tag: '「チャート根拠のみでコールします」',
 room_insider: '内部情報部屋', room_insider_tag: '「兄貴を信じろ、確かな情報だ」',
 room_whale: 'クジラ士官学校', room_whale_tag: '「勢力の動きを先読みする」',
 room_oracle: 'オラクルの部屋', room_oracle_tag: '「的中率で証明します」',
 // 部屋主コール (call_up = 買い誘導, call_down = 売り誘導)
 call_up_1: '{coin} 今入れば2倍いく', call_up_2: '{coin} 上場情報入手、フルベット確定',
 call_up_3: '{coin} 勢力の仕込み確認、今がチャンス', call_up_4: '{coin} 底固め完了、追加買いコール',
 call_down_1: '{coin} 今投げろ、急落が来る', call_down_2: '{coin} 勢力離脱シグナル、損切り確定',
 call_down_3: '{coin} 高値だ、利確して抜けろ', call_down_4: '{coin} 悪材料が出る、先に整理',
 ad_vip_room: 'VIPシグナル部屋 入場券',

 // === Info Broker (Sprint 3a) ===
 shop_title: '情報屋', shop_intro: '取引所の裏路地。ゲームマネーで情報を売る。高くて、曖昧だ。',
 shop_bought: '情報入手', shop_no_info: '今は売る情報がない',
 shop_whale_hint: '勢力動向の耳打ち', shop_whale_hint_desc: '動きのあるコインを一つ指す（段階までは不明）',
 shop_news_tip: '次のニュースコイン', shop_news_tip_desc: '次のニュースがどのコインを打つかだけ（方向は秘密）',
 shop_room_leak: 'シグナル部屋の裏調査', shop_room_leak_desc: 'ある部屋の信頼度ランクをおおまかに漏らす',
 shop_hint_whale: '「{coin}…最近デカい奴が仕込んでるって噂だ」',
 shop_hint_news: '「次のデカい案件は{coin}で来るらしい」',
 shop_hint_room: '「{room}？あの部屋の信頼度は{band}くらいだ」',
 shop_band_low: '低', shop_band_mid: '中', shop_band_high: '高',

 // === リーディングルームのライブチャット (Sprint 3b) ===
 lrc_quiet: '部屋は静かだ...',
 rc_me: '自分', rc_moon: '爆上げだ', rc_cut: '損切りした', rc_watch: '様子見',
 // 擁護・煽り
 chat_advocate_1: '行くぞ皆さん', chat_advocate_2: 'ガチホは勝つ',
 chat_advocate_3: 'これはマジで行く', chat_advocate_4: '今乗らないと一生後悔',
 chat_advocate_5: 'フルで買った', chat_advocate_6: '今回は雰囲気が違う',
 chat_advocate_7: 'ホルダーは最後に笑う', chat_advocate_8: 'これが最後の底値',
 chat_advocate_9: '爆上げ行くぞ', chat_advocate_10: '今乗らないと稲妻乞食',
 chat_advocate_11: '勢力様ここにいます', chat_advocate_12: 'シード全部ぶち込んだ',
 chat_advocate_13: '俺だけコイン持ってない', chat_advocate_14: '利確は芸術だ',
 chat_advocate_15: 'ミームコインは雰囲気で買う', chat_advocate_16: '出来高爆発掴め',
 chat_advocate_17: '噴くぞ来た', chat_advocate_18: 'ゴールデンクロス来た',
 chat_advocate_19: '個人投資家の勝利だ', chat_advocate_20: '今日は焼肉コース',
 chat_advocate_21: '建値回復が目前だ', chat_advocate_22: 'この部屋信じて行く',
 chat_advocate_23: '押し目で仕込んだ', chat_advocate_24: '次のテンバガーはこれ',
 chat_advocate_25: '反発の形が出た', chat_advocate_26: '今が本物の底',
 chat_advocate_27: '緑ロウソク点いた', chat_advocate_28: 'ガチホ3年目が笑う',
 chat_advocate_29: 'この部屋信じてガチホ行く', chat_advocate_30: '下がったとき拾うのが実力だ', chat_advocate_31: '勢力が付いた今回は違う', chat_advocate_32: 'ナンピンで平均取得価格下げた',
 chat_advocate_33: '今が最後の拾いチャンス', chat_advocate_34: 'ホルダー認証ここにいる', chat_advocate_35: '反発来るぞ掴め皆さん', chat_advocate_36: 'このコイン見るたび欲しくなる買い増す',
 chat_advocate_37: '赤ロウソクが心地いい買い場だ', chat_advocate_38: 'クジラの仕込みが入ったって', chat_advocate_39: 'ガチホ3年目笑う準備できた', chat_advocate_40: '今日は焼肉食いに行く',
 chat_advocate_41: 'ガチホは勝つ3年信じてる', chat_advocate_42: 'これ買わないと稲妻乞食コース', chat_advocate_43: 'チキン代今日ここで稼ぐ', chat_advocate_44: '指が先に買いを押した',
 chat_advocate_45: '今が底だマジで今回は', chat_advocate_46: '爆上げ行くぞ心臓構えろ', chat_advocate_47: 'この部屋のコール今回は信じる', chat_advocate_48: 'リーディング部屋信じてフルポジ',
 chat_advocate_49: 'ジャガイモ農業やめてここに来た', chat_advocate_50: '今日は口座が親孝行だ',
 // 冷笑・疑い
 chat_cynic_1: '変な噂を流すな', chat_cynic_2: '含み損か?',
 chat_cynic_3: '個人投資家の振り落としだろ', chat_cynic_4: '逃げるのも頭のうち',
 chat_cynic_5: 'またこの部屋か', chat_cynic_6: 'クジラの踊りに乗るな',
 chat_cynic_7: 'またポンプの連投', chat_cynic_8: 'このコールで買うのは養分',
 chat_cynic_9: 'この部屋また先走り', chat_cynic_10: '希望回路を回すな',
 chat_cynic_11: '勢力が喜ぶだろうな', chat_cynic_12: 'このコール逆張りで勝てる',
 chat_cynic_13: 'チャートが心電図かよ', chat_cynic_14: 'またナンピン誘導してる',
 chat_cynic_15: 'ラグプル準備の臭いがする', chat_cynic_16: '個人投資家の弾除け募集中',
 chat_cynic_17: 'デッドキャットに騙されるな', chat_cynic_18: '先走りはいつもこうだ',
 chat_cynic_19: 'このコール信じる奴がカモ', chat_cynic_20: 'ポンプ部屋のお約束が出た',
 chat_cynic_21: '個人だけ焼く展開', chat_cynic_22: '勢力の出口を作ってやってる',
 chat_cynic_23: 'これ上場廃止コースなのに笑う', chat_cynic_24: '希望を売る部屋だな',
 chat_cynic_25: 'また誰か含み損か', chat_cynic_26: 'バブルが剥がれれば答えが出る',
 chat_cynic_27: 'この部屋の売り板が勢力だ', chat_cynic_28: '結局個人が最後の買い手',
 chat_cynic_29: 'この部屋の確信っぷりがむしろ不安だ', chat_cynic_30: '扇動すごいな気をつけろ個人ども', chat_cynic_31: 'ナンピン誘導の臭いがする', chat_cynic_32: 'この確信は勢力のシナリオだ',
 chat_cynic_33: 'この部屋のコールはいつも逆に行く', chat_cynic_34: '希望を売る奴だけ笑う部屋', chat_cynic_35: 'また誰かが弾除けになるな', chat_cynic_36: '赤ロウソクが心地いいって精神勝利',
 chat_cynic_37: 'クジラの仕込みって話が出たら用心', chat_cynic_38: 'ガチホ3年目が自慢か', chat_cynic_39: '焼肉は勢力だけが食う', chat_cynic_40: 'この部屋信じてたらカップ麺コースだ',
 chat_cynic_41: 'この部屋また後始末の始まりだな', chat_cynic_42: '逃げるのは頭のうちここは違うが', chat_cynic_43: 'チキン代稼ごうとしてチキン店手放すぞ', chat_cynic_44: 'リーディング部屋信じた瞬間カモ確定',
 chat_cynic_45: '今が底だと三日目のその台詞', chat_cynic_46: '指に買いを押させる誘導だな', chat_cynic_47: 'この部屋のコール逆張りで勝てるお約束', chat_cynic_48: '勢力の後始末に皿を差し出すな',
 chat_cynic_49: 'ジャガイモ農業の方がマシとここで悟る', chat_cynic_50: '稲妻乞食コースの案内所だなここ',
 // パニック・自嘲
 chat_panic_1: '含み損は俺だけか', chat_panic_2: '損切りの時か?',
 chat_panic_3: 'これは上場廃止コース', chat_panic_4: 'ガチホしすぎて焼かれた',
 chat_panic_5: '俺のシードどこ行った', chat_panic_6: '原資半分になった',
 chat_panic_7: 'だからコインはつらい', chat_panic_8: 'メンタル崩壊した',
 chat_panic_9: 'カップ麺でも作りに行く', chat_panic_10: '口座が溶ける',
 chat_panic_11: '含み損だけどガチホでいいか', chat_panic_12: '俺の口座が焦土化',
 chat_panic_13: '今日も涙のカップ麺', chat_panic_14: '反発待ってたら老ける',
 chat_panic_15: '損切りボタンが押せない', chat_panic_16: '希望は贅沢だった',
 chat_panic_17: '稲妻乞食になりつつある', chat_panic_18: 'このコイン答えがない',
 chat_panic_19: '個人投資家地獄オープンした', chat_panic_20: '高値から半値だ',
 chat_panic_21: 'ナンピンして全部溶かした', chat_panic_22: '支持線割れたどうする',
 chat_panic_23: 'メンタル管理ができない', chat_panic_24: '今日も青ロウソクパーティ',
 chat_panic_25: '逃げるタイミング逃した', chat_panic_26: 'ガチホがこんなに辛いとは',
 chat_panic_27: '俺のシードが瞬殺された', chat_panic_28: 'もう祈るしかない',
 chat_panic_29: 'この部屋に従ってナンピンしたもっと含んだ', chat_panic_30: '俺のシードが溶けてるマジで', chat_panic_31: '俺だけ高値掴みしたのか', chat_panic_32: '損切りできずここまで来た',
 chat_panic_33: '建値来たら抜けると言って抜けられない', chat_panic_34: 'クジラが投げて出たってどうする', chat_panic_35: '利確した奴だけ人間だったな', chat_panic_36: 'チャートが地下室を掘る怖い',
 chat_panic_37: 'メンタル勝負で崩れ落ちた', chat_panic_38: 'この部屋の雰囲気が葬式になった', chat_panic_39: '今日も口座見るのが怖い', chat_panic_40: 'ガチホ3年目まだマイナス',
 chat_panic_41: '俺だけ含み損だ俺だけ含み損だ', chat_panic_42: 'チキン代稼ごうとしてチキン店手放した', chat_panic_43: 'ナンピンしてただ溺死した', chat_panic_44: '俺のシードどこ行った本気で',
 chat_panic_45: 'リーディング部屋信じた俺がバカだった', chat_panic_46: '損切りボタンが物理的に押せない', chat_panic_47: '今が底だと三日目泣いてる', chat_panic_48: '逃げるのは頭のうちだが俺は違った',
 chat_panic_49: 'ジャガイモ農業すればよかったマジで後悔', chat_panic_50: '稲妻乞食コース順調に進行中だ',
 // 分析・アドバイス
 chat_analysis_1: 'チャート見れば分かる', chat_analysis_2: '出来高を見ろ',
 chat_analysis_3: '底を拾え', chat_analysis_4: '今がナンピンの時',
 chat_analysis_5: '支持線を守ってる', chat_analysis_6: 'ゴールデンクロス来るぞ',
 chat_analysis_7: '分割買いが定石', chat_analysis_8: '出来高ないなら押し目',
 chat_analysis_9: '勢力の仕込み跡が見える', chat_analysis_10: 'チャートが右肩上がりを描く',
 chat_analysis_11: '抵抗線突破すれば噴く', chat_analysis_12: '出来高伴えば本物だ',
 chat_analysis_13: '短期は損切りライン守れ', chat_analysis_14: 'デッドキャット警戒で様子見',
 chat_analysis_15: '押し目買いが正解', chat_analysis_16: '移動平均線が正配列になった',
 chat_analysis_17: 'レンジ上限が抵抗だ', chat_analysis_18: '出来高ないなら参入禁止',
 chat_analysis_19: '勢力の売り板を確認しろ', chat_analysis_20: '分割売りでリスク管理',
 chat_analysis_21: 'チャート心理が重要だ', chat_analysis_22: '高値で売り物が出る',
 chat_analysis_23: '支持線割れたら損切り', chat_analysis_24: 'トレンド生きてるならホールド',
 chat_analysis_25: 'ボラ大きいときは様子見', chat_analysis_26: '勢力のサイクルを読め',
 chat_analysis_27: '出来高死ぬと下落だ', chat_analysis_28: 'リスク管理が実力だ',
 chat_analysis_29: 'この確信には根拠がない様子見だ', chat_analysis_30: 'ナンピンはトレンド確認してからやれ', chat_analysis_31: 'まずクジラの財布の動きを見ろ', chat_analysis_32: '出来高ない反発は罠だ',
 chat_analysis_33: '損切りライン決めて入るものだ', chat_analysis_34: '赤ロウソクで拾うなら分割でやれ', chat_analysis_35: '建値心理でのナンピンは禁物だ', chat_analysis_36: '勢力の仕込み説はまず検証しろ',
 chat_analysis_37: '利確も計画が必要だ', chat_analysis_38: '地下室行くときは手を出すな', chat_analysis_39: 'メンタル管理が即リスク管理だ', chat_analysis_40: '確信が強い部屋ほど疑え',
 chat_analysis_41: 'リーディング部屋のコールは根拠から確認しろ', chat_analysis_42: '底だと三日目なら底じゃない', chat_analysis_43: 'ナンピン前にトレンド見ろ溺死するぞ', chat_analysis_44: '損切りライン決めて入れば稲妻乞食にならない',
 chat_analysis_45: '勢力の後始末シグナルは出来高に出る', chat_analysis_46: '逃げるのは頭のうち計画から立てろ', chat_analysis_47: 'チキン代狙ってシード全焼するぞ分割しろ', chat_analysis_48: 'まずクジラの財布の動きをチェックしろ',
 chat_analysis_49: '反発は出来高伴うときだけ本物だ', chat_analysis_50: '利確は芸術損切りは技術どっちも計画だ',
 // NPCの反応 (リアクションへの返し)
 chat_echo_up_1: '行くぞ俺も乗る', chat_echo_up_2: '兄貴を信じる',
 chat_echo_up_3: '一緒にアペる', chat_echo_up_4: '先走りは禁物だぞ',
 chat_echo_up_5: '兄貴信じてフルポジ行く', chat_echo_up_6: '俺も下がったとき拾った', chat_echo_up_7: '勢力が付いたらゲーム終了', chat_echo_up_8: '赤ロウソクだから買い増した',
 chat_echo_up_9: 'ガチホの構え俺も決めた', chat_echo_up_10: '今回は感触いい行くぞ', chat_echo_up_11: 'ナンピンで平均取得価格下げた', chat_echo_up_12: '焼肉食う準備しとこう',
 chat_echo_up_13: 'クジラの仕込みなら本物だ', chat_echo_up_14: '利確のタイミングだけしっかり掴もう', chat_echo_up_15: 'この部屋久々に確信持てる', chat_echo_up_16: '反発掴んだ爆上げ行くぞ',
 chat_echo_down_1: '俺も損切りした', chat_echo_down_2: '臆病者は先に逃げる',
 chat_echo_down_3: '賢明な判断', chat_echo_down_4: '俺はまだ耐える',
 chat_echo_down_5: '俺も損切りが正解だった', chat_echo_down_6: '高値掴みは俺だけじゃないな', chat_echo_down_7: 'シードが溶ける音が聞こえる', chat_echo_down_8: '希望回路を回すのやめる',
 chat_echo_down_9: '利確した奴だけ勝ったな', chat_echo_down_10: '建値は水の彼方だ', chat_echo_down_11: 'カップ麺コースだ今日も', chat_echo_down_12: '勢力が全部投げて出た',
 chat_echo_down_13: '地下室を掘るチャート怖い', chat_echo_down_14: 'メンタル勝負で負けた', chat_echo_down_15: '損切りボタンが押せない', chat_echo_down_16: '賢明に俺は足を抜いた',
 chat_echo_neut_1: '様子見も実力', chat_echo_neut_2: '見守ろう',
 chat_echo_neut_3: '決められない奴は負ける', chat_echo_neut_4: '俺も一旦待つ',
 chat_echo_neut_5: '確信持てるまで様子見', chat_echo_neut_6: '根拠のない確信は危険だ', chat_echo_neut_7: 'ナンピンはトレンド見てから', chat_echo_neut_8: 'まずクジラの動きを確認',
 chat_echo_neut_9: '出来高ないなら罠かもしれない', chat_echo_neut_10: '損切りライン決めて様子見する', chat_echo_neut_11: '赤ロウソクは分割で入る', chat_echo_neut_12: '確信がむしろ不安だ',
 chat_echo_neut_13: '利確も計画が必要だぞ', chat_echo_neut_14: '地下室行くなら手を出さない', chat_echo_neut_15: 'まずメンタル管理しよう', chat_echo_neut_16: 'とりあえず様子見が最善策',
 // 噂 (真偽は隠されている)
 rumor_tag: '噂', rumor_true: '本物', rumor_fake: 'デマ',
 rumor_check_btn: '真偽確認', rumor_check_sub: '広告を見てファクトチェック',
 rumor_listing: '{coin}が大手取引所に上場する情報を掴んだ',
 rumor_accumulate: 'クジラが{coin}の仕込みを終えたらしい',
 rumor_partnership: '{coin}の大型提携発表が間近だとか',
 rumor_delist: '{coin}が明日上場廃止になるらしい',
 rumor_rugpull: '{coin}の開発者が持ち逃げ準備中だとか',
 rumor_dump: 'クジラが{coin}を投げ売りするらしい',
} as Record<string, string>;
